import React, { useState } from "react";
import { motion, useReducedMotion } from "framer-motion";
import { LockIcon, LockOpenIcon, SparklesIcon } from "lucide-react";
interface UnlockGateProps {
  name: string;
  onUnlock: () => void;
}
export function UnlockGate({
  name,
  onUnlock
}: UnlockGateProps) {
  const reduce = useReducedMotion();
  const [opening, setOpening] = useState(false);
  const handleClick = () => {
    if (opening) return;
    setOpening(true);
    window.setTimeout(onUnlock, 420);
  };
  return <motion.div className="relative mt-12 overflow-hidden rounded-3xl border-2 border-dashed border-rose-400 bg-white px-6 py-10 text-center sm:px-10 sm:py-12" initial={{
    opacity: 0,
    y: 16
  }} animate={{
    opacity: 1,
    y: 0
  }} exit={{
    opacity: 0,
    scale: 1.04
  }} transition={{
    duration: 0.25,
    ease: [0.23, 1, 0.32, 1]
  }} data-id="element-398" data-mp="3ukyjfsjce0ts">
      <p className="font-serif text-2xl font-semibold text-cocoa sm:text-3xl" data-id="element-399" data-mp="36wyxd5wz6ylj">Tu recomendación personalizada ya está lista.</p>

      <div className="relative mx-auto mt-8 flex h-24 w-24 items-center justify-center" data-id="element-400" data-mp="26i2d6c92iy7k">
        {!reduce && !opening && <>
            <motion.span className="absolute inset-0 rounded-full bg-rose-400" animate={{
          scale: [1, 1.5],
          opacity: [0.35, 0]
        }} transition={{
          duration: 1.6,
          repeat: Infinity,
          ease: "easeOut"
        }} aria-hidden="true" data-id="element-401" data-mp="21ig2a9gppu1x" />
            <motion.span className="absolute inset-0 rounded-full bg-rose-400" animate={{
          scale: [1, 1.5],
          opacity: [0.35, 0]
        }} transition={{
          duration: 1.6,
          repeat: Infinity,
          ease: "easeOut",
          delay: 0.8
        }} aria-hidden="true" data-id="element-402" data-mp="1nr1elpbv14oj" />
          </>}
        <motion.span className="relative flex h-24 w-24 items-center justify-center rounded-full bg-rose-600 text-white shadow-lg" animate={opening ? {
        scale: [1, 1.25, 0.9],
        rotate: 0
      } : reduce ? {} : {
        rotate: [0, -12, 12, -8, 8, 0]
      }} transition={opening ? {
        duration: 0.3,
        ease: "easeOut"
      } : {
        duration: 0.6,
        repeat: Infinity,
        repeatDelay: 1.6
      }} data-id="element-403" data-mp="1sq5rapxztkjm">
          {opening ? <LockOpenIcon className="h-10 w-10" aria-hidden="true" data-id="element-404" data-mp="1yjhinimfvqbu" /> : <LockIcon className="h-10 w-10" aria-hidden="true" data-id="element-405" data-mp="23i28co42erm1" />}
        </motion.span>
      </div>

      <p className="mt-6 inline-flex items-center gap-2 rounded-full bg-blush-50 px-4 py-2 text-base font-semibold text-rose-700" data-id="element-406" data-mp="16s1q77y7b9dp">
        <LockIcon className="h-4 w-4" aria-hidden="true" data-id="element-407" data-mp="1atn6l39y25sn" />
        Recomendación bloqueada para {name || "vos"}
      </p>
      <p className="mx-auto mt-4 max-w-md text-base leading-relaxed text-cocoa-soft" data-id="element-408" data-mp="1fuaxzq234one">
        Haz clic abajo para desbloquear el siguiente paso recomendado según tu resultado.
      </p>

      <motion.button type="button" onClick={handleClick} disabled={opening} className="mx-auto mt-8 inline-flex w-full max-w-md items-center justify-center gap-2 rounded-full bg-leaf px-6 py-4 text-sm font-bold uppercase tracking-wide text-white shadow-md transition-colors duration-150 hover:bg-leaf-dark focus:outline-none focus-visible:ring-2 focus-visible:ring-leaf focus-visible:ring-offset-2 sm:text-base" animate={reduce || opening ? {} : {
      scale: [1, 1.04, 1]
    }} transition={{
      duration: 1.2,
      repeat: Infinity,
      ease: "easeInOut"
    }} whileTap={{
      scale: 0.96
    }} data-id="element-409" data-mp="2r7504osey0u9">
        <SparklesIcon className="h-5 w-5 shrink-0" aria-hidden="true" data-id="element-410" data-mp="3syxtakkgn9ea" />
        Desbloquear mi recomendación personalizada
      </motion.button>
    </motion.div>;
}